module.exports = __webpack_public_path__ + "pic4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pic4.jpg
// module id = 1581
// module chunks = 4